import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";


const FONT_LIST = [

"Inter",
"Roboto",
"Open Sans",
"Work Sans",
"Raleway",
"Ubuntu",
"Nunito",
"Montserrat",
"Poppins",
"Noto Sans",
"Karla",
"Mulish",
"Quicksand",
"Cabin",
"Fira Sans",
"Manrope",
"Hind",
"Hind Madurai",
"Noto Sans Display",
"Lora",
"Merriweather",
"Playfair Display",
"Libre Baskerville",
"PT Serif",
"Source Serif 4",
"Noto Serif",
"Crimson Pro",
"EB Garamond",
"Spectral",
"Noto Serif Display"
];


export default function PrescriptionSettings() {
  const [settings, setSettings] = useState({
   headerBox: {
  content: "VEDALAYA AYURVEDA<br/>Dr. Ankit Patil (BAMS)",
  style: {
    fontFamily: "Times New Roman",
    fontSize: 18,
    lineHeight: 1.5,
    paragraphSpacing: 8,
    textAlign: "center"
  },
  tools: {
    bold: true,
    italic: false,
    underline: false,
    highlight: false,
    bulletList: false,
    orderedList: false,
    align: true
  }
},

footerBox: {
  content: "Follow pathya–apathya strictly.<br/>Next follow-up in 7 days.",
  style: {
    fontFamily: "Times New Roman",
    fontSize: 14,
    lineHeight: 1.5,
    paragraphSpacing: 8,
    textAlign: "right"
  },
  tools: {
    bold: false,
    italic: false,
    underline: false,
    highlight: false,
    bulletList: false,
    orderedList: false,
    align: true
  }
},

    orientation: "portrait",
    strokeWidth: 3,
    penColor: "#111827",
    columnRatio: 30,

    // OPD PRINT CONTROL
showConsultantHeader: true,
showFooter: true,
topOffset: 0,

// ✅ NOW IN MM
footerOffset: 10,

/* ===== TYPED EDITOR DEFAULTS ===== */
typedEditor: {
  complaints: {
    style: {
  fontFamily: "Times New Roman",
  fontSize: 16,
  lineHeight: 1.5,
  paragraphSpacing: 8,
  textAlign: "left",

  bulletType: "disc",     // disc circle square dash
  numberType: "decimal"   // decimal roman alpha
}
,
    tools: {
      bold: false,
      italic: false,
      underline: false,
      highlight: false,
      bulletList: false,
      orderedList: false,
      align: false
    }
  },

  diagnosis: {
    style: {
  fontFamily: "Times New Roman",
  fontSize: 16,
  lineHeight: 1.5,
  paragraphSpacing: 8,
  textAlign: "left",

  bulletType: "disc",     // disc circle square dash
  numberType: "decimal"   // decimal roman alpha
}
,
    tools: {
      bold: false,
      italic: false,
      underline: false,
      highlight: false,
      bulletList: false,
      orderedList: false,
      align: false
    }
  },

  advice: {
    style: {
  fontFamily: "Times New Roman",
  fontSize: 16,
  lineHeight: 1.5,
  paragraphSpacing: 8,
  textAlign: "left",

  bulletType: "disc",     // disc circle square dash
  numberType: "decimal"   // decimal roman alpha
}
,
    tools: {
      bold: true,
      italic: true,
      underline: true,
      highlight: false,
      bulletList: true,
      orderedList: true,
      align: true
    }
  },

  notes: {
    style: {
  fontFamily: "Times New Roman",
  fontSize: 16,
  lineHeight: 1.5,
  paragraphSpacing: 8,
  textAlign: "left",

  bulletType: "disc",     // disc circle square dash
  numberType: "decimal"   // decimal roman alpha
}
,
    tools: {
      bold: true,
      italic: false,
      underline: false,
      highlight: true,
      bulletList: false,
      orderedList: false,
      align: false
    }
  }
},

    /* ===== NEW — Doctor Stamp: filled once, reused on every print.
       The visit date itself is NOT stored here — it always comes
       from the prescription being printed. */
    doctorStamp: {
      name: "",
      registrationNo: "",
      signatureImageUrl: ""
    }

  });

  const [saving, setSaving] = useState(false);
  const [stampUploading, setStampUploading] = useState(false);
  const [stampUploadError, setStampUploadError] = useState("");
  const navigate = useNavigate();

  /* Upload the doctor's signature/stamp image via the existing
     generic /api/upload endpoint (Cloudinary-backed), then store the
     returned permanent URL on the settings object. */
  const handleStampImageUpload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = ""; // allow re-selecting the same file later
    if (!file) return;
    setStampUploadError("");
    setStampUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await api.post("/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const url = res.data?.url;
      if (!url) throw new Error("No URL returned");
      setSettings(prev => ({
        ...prev,
        doctorStamp: { ...prev.doctorStamp, signatureImageUrl: url }
      }));
    } catch (err) {
      setStampUploadError("Upload failed. Please try again.");
    } finally {
      setStampUploading(false);
    }
  };

/* LOAD SETTINGS FROM API (per-doctor) */
useEffect(() => {
  api.get("/doctor/prescription-settings")
    .then(res => {
      if (!res.data) return;
      const parsed = res.data;
      setSettings(prev => ({
        ...prev,
        ...parsed,
        typedEditor: {
          complaints: {
            style: { ...prev.typedEditor.complaints.style, ...(parsed.typedEditor?.complaints?.style || {}) },
            tools: { ...prev.typedEditor.complaints.tools, ...(parsed.typedEditor?.complaints?.tools || {}) }
          },
          diagnosis: {
            style: { ...prev.typedEditor.diagnosis.style, ...(parsed.typedEditor?.diagnosis?.style || {}) },
            tools: { ...prev.typedEditor.diagnosis.tools, ...(parsed.typedEditor?.diagnosis?.tools || {}) }
          },
          advice: {
            style: { ...prev.typedEditor.advice.style, ...(parsed.typedEditor?.advice?.style || {}) },
            tools: { ...prev.typedEditor.advice.tools, ...(parsed.typedEditor?.advice?.tools || {}) }
          },
          notes: {
            style: { ...prev.typedEditor.notes.style, ...(parsed.typedEditor?.notes?.style || {}) },
            tools: { ...prev.typedEditor.notes.tools, ...(parsed.typedEditor?.notes?.tools || {}) }
          }
        }
      }));
    })
    .catch(() => {});
}, []);

  /* SAVE SETTINGS via API (per-doctor) */
  const saveSettings = async () => {
    setSaving(true);
    try {
      await api.post("/doctor/prescription-settings", settings);
      alert("Prescription settings saved");
    } catch {
      alert("Failed to save settings. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  /* MM → PX (for preview only) */
  const mmToPx = (mm) => mm * 3.78;


/* ===== SINGLE BOX UPDATE ===== */
const updateBoxEditor = (box, key, value) => {

  if (box === "headerBox" || box === "footerBox") {
    setSettings(prev => ({
      ...prev,
      [box]: {
        ...prev[box],
        [key]: value
      }
    }));
    return;
  }

  setSettings(prev => ({
    ...prev,
    typedEditor: {
      ...prev.typedEditor,
      [box]: {
        ...prev.typedEditor[box],
        [key]: value
      }
    }
  }));
};
/* ===== TOOL PERMISSION UPDATE ===== */
const updateBoxTool = (box, tool, value) => {

  if (box === "headerBox" || box === "footerBox") {
    setSettings(prev => ({
      ...prev,
      [box]: {
        ...prev[box],
        tools: {
          ...prev[box].tools,
          [tool]: value
        }
      }
    }));
    return;
  }

  setSettings(prev => ({
    ...prev,
    typedEditor: {
      ...prev.typedEditor,
      [box]: {
        ...prev.typedEditor[box],
        tools: {
          ...prev.typedEditor[box].tools,
          [tool]: value
        }
      }
    }
  }));
};
const goBackToPrescription = () => {

  const keys = Object.keys(localStorage);
  const draftKey = keys.find(k => k.startsWith("rxDraft_"));

  if (!draftKey) {
    navigate("/staff-portal/dashboard");
    return;
  }

  try {
    const draft = JSON.parse(localStorage.getItem(draftKey));

    if (draft?.fromUrl) {
      navigate(draft.fromUrl);
      return;
    }

  } catch (err) {
    console.log("Restore failed", err);
  }

  navigate("/staff-portal/dashboard");
};


  return (
    <div className="flex gap-6 h-screen p-6 bg-gray-100">

      {/* LEFT PANEL */}
      <div className="w-[50%] min-w-[480px] border rounded-xl p-5 space-y-4 bg-white overflow-y-auto shadow">

        <div className="flex justify-between items-center">
<h1 className="text-xl font-semibold">Prescription Settings</h1>

<button
onClick={goBackToPrescription}
className="px-3 py-1 text-sm rounded bg-blue-600 text-white hover:bg-blue-700"
>
⬅ Back to Prescription
</button>

</div>

       {/* HEADER */}
<div>
  <label className="text-sm font-semibold">Header</label>
  <textarea
    rows={4}
    className="input"
    value={settings.headerBox.content}
    onChange={(e) =>
      setSettings(prev => ({
        ...prev,
        headerBox: {
          ...prev.headerBox,
          content: e.target.value
        }
      }))
    }
  />
</div>



        {/* FOOTER */}
        <div className="border rounded-lg p-3 bg-white">
          <label className="text-sm font-semibold text-blue-700">
            Footer Text (Print Bottom)
          </label>
          <textarea
            rows={3}
            className="input mt-2"
          value={settings.footerBox.content}
onChange={(e) =>
  setSettings(prev => ({
    ...prev,
    footerBox: {
      ...prev.footerBox,
      content: e.target.value
    }
  }))
}

          />
          <p className="text-xs text-gray-500 mt-1">
            This appears at bottom-right of printed prescription.
          </p>
        </div>

        {/* ===== DOCTOR STAMP — filled once, reused on every print ===== */}
        <div className="border rounded-lg p-3 bg-white">
          <label className="text-sm font-semibold text-blue-700">
            Doctor Stamp
          </label>
          <p className="text-xs text-gray-500 mt-1 mb-3">
            Fill this in once. It's saved to your account and automatically
            shown on every prescription you print or send — you don't need
            to re-enter it per patient visit. (The date shown on each
            prescription is always that visit's own date, not stored here.)
          </p>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-medium text-gray-600">Doctor Name</label>
              <input
                className="input mt-1"
                placeholder="e.g. Dr. Ankit Patil (BAMS)"
                value={settings.doctorStamp?.name || ""}
                onChange={(e) =>
                  setSettings(prev => ({
                    ...prev,
                    doctorStamp: { ...prev.doctorStamp, name: e.target.value }
                  }))
                }
              />
            </div>
            <div>
              <label className="text-xs font-medium text-gray-600">Registration Number</label>
              <input
                className="input mt-1"
                placeholder="e.g. MH-AYU-12345"
                value={settings.doctorStamp?.registrationNo || ""}
                onChange={(e) =>
                  setSettings(prev => ({
                    ...prev,
                    doctorStamp: { ...prev.doctorStamp, registrationNo: e.target.value }
                  }))
                }
              />
            </div>
          </div>

          <div className="mt-3">
            <label className="text-xs font-medium text-gray-600">
              Signature / Stamp Image
            </label>
            <div className="flex items-center gap-3 mt-1">
              {settings.doctorStamp?.signatureImageUrl ? (
                <img
                  src={settings.doctorStamp.signatureImageUrl}
                  alt="Doctor signature/stamp"
                  style={{ height: 48, maxWidth: 160, objectFit: "contain", border: "1px solid #e5e7eb", borderRadius: 6, background: "#fff" }}
                />
              ) : (
                <div style={{ height: 48, width: 160, border: "1px dashed #d1d5db", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "#9ca3af" }}>
                  No image uploaded
                </div>
              )}
              <label className="px-3 py-1.5 text-xs rounded bg-blue-600 text-white hover:bg-blue-700 cursor-pointer">
                {stampUploading ? "Uploading…" : "Upload Image"}
                <input
                  type="file"
                  accept="image/*"
                  className="hidden"
                  disabled={stampUploading}
                  onChange={handleStampImageUpload}
                />
              </label>
              {settings.doctorStamp?.signatureImageUrl && (
                <button
                  type="button"
                  className="px-3 py-1.5 text-xs rounded border border-red-300 text-red-600 hover:bg-red-50"
                  onClick={() =>
                    setSettings(prev => ({
                      ...prev,
                      doctorStamp: { ...prev.doctorStamp, signatureImageUrl: "" }
                    }))
                  }
                >
                  Remove
                </button>
              )}
            </div>
            {stampUploadError && (
              <p className="text-xs text-red-600 mt-1">{stampUploadError}</p>
            )}
            <p className="text-xs text-gray-500 mt-1">
              A scanned signature or clinic stamp, PNG with a transparent
              background works best. Prints bottom-left of every prescription.
            </p>
          </div>
        </div>

        {/* FOOTER POSITION */}
        <div>
          <label className="text-sm font-semibold">
            Footer Position (mm from bottom)
          </label>
          <input
            type="range"
            min="0"
            max="50"
            value={settings.footerOffset}
            onChange={(e) =>
              setSettings({
                ...settings,
                footerOffset: Number(e.target.value)
              })
            }
          />
          <p className="text-xs text-gray-500">
            {settings.footerOffset} mm
          </p>
        </div>

        {/* HEADER TOGGLE */}
        <div>
          <label className="text-sm font-semibold">
            Show Consultant Header in Print
          </label>
          <input
            type="checkbox"
            checked={settings.showConsultantHeader}
            onChange={(e) =>
              setSettings({
                ...settings,
                showConsultantHeader: e.target.checked
              })
            }
            className="ml-2"
          />
        </div>
        {/* FOOTER TOGGLE */}
<div>
  <label className="text-sm font-semibold">
    Show Footer in Print
  </label>
  <input
    type="checkbox"
    checked={settings.showFooter}
    onChange={(e) =>
      setSettings({
        ...settings,
        showFooter: e.target.checked
      })
    }
    className="ml-2"
  />
</div>

        {/* PRE-PRINTED PAPER MODE EXPLANATION */}
        <div className="border rounded-lg p-3 bg-amber-50 border-amber-200">
          <p className="text-xs font-semibold text-amber-800 mb-1">📄 Pre-Printed OPD Paper Mode</p>
          <p className="text-xs text-amber-700">
            If your OPD paper already has a <strong>printed header/footer</strong> (clinic name, logo, etc.),
            turn OFF the header and footer toggles above. Use <strong>Top Offset</strong> to push 
            content below your pre-printed header, and <strong>Footer Position</strong> to leave space 
            above your pre-printed footer. The digital content will print in the blank body area only.
          </p>
          <div className="mt-2 flex gap-3 flex-wrap">
            <button
              type="button"
              className="text-xs px-3 py-1 bg-amber-600 text-white rounded hover:bg-amber-700"
              onClick={() => setSettings(prev => ({ ...prev, showConsultantHeader: false, showFooter: false }))}
            >
              ✓ Use Pre-Printed Paper
            </button>
            <button
              type="button"
              className="text-xs px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
              onClick={() => setSettings(prev => ({ ...prev, showConsultantHeader: true, showFooter: true }))}
            >
              ✓ Use Digital Header/Footer
            </button>
          </div>
        </div>

        {/* TOP OFFSET */}
        <div>
          <label className="text-sm font-semibold">
            Top Offset — skip pre-printed header space (mm)
          </label>
          <input
            type="range"
            min="0"
            max="80"
            value={settings.topOffset}
            onChange={(e) =>
              setSettings({
                ...settings,
                topOffset: Number(e.target.value)
              })
            }
          />
          <p className="text-xs text-gray-500">
            {settings.topOffset} mm
          </p>
        </div>

        {/* ORIENTATION */}
        <div>
          <label className="text-sm font-semibold">Orientation</label>
          <select
            className="input"
            value={settings.orientation}
            onChange={(e) =>
              setSettings({ ...settings, orientation: e.target.value })
            }
          >
            <option value="portrait">Portrait (A4)</option>
            <option value="landscape">Landscape (A4)</option>
          </select>
        </div>

        {/* COLUMN RATIO */}
        <div>
          <label className="text-sm font-semibold">
            Column Ratio (History / Advice)
          </label>
          <input
            type="range"
            min="20"
            max="40"
            value={settings.columnRatio}
            onChange={(e) =>
              setSettings({
                ...settings,
                columnRatio: Number(e.target.value)
              })
            }
          />
          <p className="text-xs text-gray-500">
            {settings.columnRatio}% / {100 - settings.columnRatio}%
          </p>
        </div>

        {/* PEN SETTINGS */}
        <div>
          <label className="text-sm font-semibold">
            Default Stroke Width
          </label>
          <input
            type="range"
            min="1"
            max="8"
            value={settings.strokeWidth}
            onChange={(e) =>
              setSettings({
                ...settings,
                strokeWidth: Number(e.target.value)
              })
            }
          />
        </div>

        <div>
          <label className="text-sm font-semibold">
            Default Pen Color
          </label>
          <input
            type="color"
            value={settings.penColor}
            onChange={(e) =>
              setSettings({ ...settings, penColor: e.target.value })
            }
            className="w-full h-10"
          />
        </div>
      

{/* ===== INDIVIDUAL BOX SETTINGS ===== */}
<div className="border rounded-lg p-3 bg-white space-y-3">
  <label className="text-sm font-semibold text-blue-700">
    Individual Box Overrides
  </label>

{["complaints","diagnosis","advice","notes","headerBox","footerBox"]
.map((box)=>{

const isHF = box==="headerBox"||box==="footerBox";

const styleObj = isHF
? settings[box]?.style
: settings.typedEditor[box]?.style;

const toolObj = isHF
? settings[box]?.tools
: settings.typedEditor[box]?.tools;

return(

<div
key={box}
className="border rounded p-2 grid grid-cols-2 gap-4 items-start
"
>

{/* ===== LEFT CONTROLS ===== */}
{/* ===== LEFT CONTROLS ===== */}
<div className="space-y-2">

<label className="text-xs font-semibold capitalize text-blue-700">
{box}
</label>

{/* ===== FONT FAMILY ===== */}
<div>
<label className="text-[11px] text-gray-600">
Font Family
</label>
<select
className="input"
value={styleObj?.fontFamily}
onChange={(e)=>
updateBoxEditor(
box,
"style",
{...styleObj,fontFamily:e.target.value}
)}
>
{FONT_LIST.map(font=>(
<option key={font} value={font}>
{font}
</option>
))}
</select>
</div>

{/* ===== FONT SIZE ===== */}
<div>
<label className="text-[11px] text-gray-600">
Font Size (px)
</label>
<input
className="input"
type="number"
value={styleObj?.fontSize}
onChange={(e)=>
updateBoxEditor(
box,
"style",
{...styleObj,fontSize:Number(e.target.value)}
)}
/>
</div>

{/* ===== LINE SPACING ===== */}
<div>
<label className="text-[11px] text-gray-600">
Line Spacing (Line Height)
</label>
<input
className="input"
type="number"
step="0.1"
value={styleObj?.lineHeight}
onChange={(e)=>
updateBoxEditor(
box,
"style",
{...styleObj,lineHeight:Number(e.target.value)}
)}
/>
</div>

{/* ===== PARAGRAPH SPACING ===== */}
<div>
<label className="text-[11px] text-gray-600">
Paragraph Spacing (Gap)
</label>
<input
className="input"
type="number"
value={styleObj?.paragraphSpacing}
onChange={(e)=>
updateBoxEditor(
box,
"style",
{...styleObj,paragraphSpacing:Number(e.target.value)}
)}
/>
</div>

<div>
<label className="text-[11px] text-gray-600">
Bullet Style
</label>
<select
className="input"
value={styleObj?.bulletType}
onChange={(e)=>
updateBoxEditor(
box,
"style",
{...styleObj, bulletType:e.target.value}
)}
>
<option value="disc">● Disc</option>
<option value="circle">○ Circle</option>
<option value="square">■ Square</option>
<option value="dash">– Dash</option>
</select>
</div>

<div>
<label className="text-[11px] text-gray-600">
Number Style
</label>
<select
className="input"
value={styleObj?.numberType}
onChange={(e)=>
updateBoxEditor(
box,
"style",
{...styleObj, numberType:e.target.value}
)}
>
<option value="decimal">1 2 3</option>
<option value="roman">I II III</option>
<option value="alpha">A B C</option>
</select>
</div>

{/* ===== STYLE TOOLS ===== */}
<div className="grid grid-cols-2 gap-2 text-xs">
{[
"bold",
"italic",
"underline",
"highlight",
"bulletList",
"orderedList"
]
.map(tool=>(
<label key={tool} className="flex items-center gap-1">
<input
type="checkbox"
checked={toolObj?.[tool]}
onChange={(e)=>updateBoxTool(box,tool,e.target.checked)}
/>
{tool}
</label>
))}
</div>

</div>
<div
  className="border rounded px-2 py-2 text-gray-800 bg-white"
  style={{
    fontFamily: styleObj?.fontFamily,
    fontSize: `${styleObj?.fontSize}px`,
    lineHeight: styleObj?.lineHeight,
    textAlign: styleObj?.textAlign,
    fontWeight: toolObj?.bold ? "700" : "400",
    fontStyle: toolObj?.italic ? "italic" : "normal",
    textDecoration: toolObj?.underline ? "underline" : "none",
    background: toolObj?.highlight ? "#fef08a" : "transparent",
    display: "flex",
    flexDirection: "column",
    gap: `${styleObj?.paragraphSpacing}px`
  }}
>
  <div>The quick brown fox jumps</div>
  <div>Over the lazy dog</div>
</div>

</div>

);

})}
</div>
                       {/* SAVE BUTTON */}
        <button
          onClick={saveSettings}
          disabled={saving}
          className="btn-primary w-full"
        >
          {saving ? "Saving..." : "Make Default (All Prescriptions)"}
        </button>
      
</div>
      {/* ================= PREVIEW ================= */}
      <div className="flex-1 border rounded-xl bg-white overflow-hidden shadow flex items-start justify-center pt-4">
        {/* Scale the 794×1123 A4 preview to fit the panel */}
        <div style={{ transform: "scale(0.62)", transformOrigin: "top center", width: 794, height: 1123, flexShrink: 0 }}>
          <div
            className="relative shadow-lg bg-white"
            style={{ width: 794, height: 1123, overflow: "hidden", boxSizing: "border-box" }}
          >
            {(() => {
              // Mirror PrescriptionPrintCombined layout() exactly
              const MM_TO_PX_PREVIEW = 3.7795275591;
              const topOff    = (settings.topOffset || 0) * MM_TO_PX_PREVIEW;
              const footerOff = (settings.footerOffset || 0) * MM_TO_PX_PREVIEW;
              const hasHeader = !!settings.showConsultantHeader;
              const hasFooter = !!settings.showFooter;

              let actualHeaderH = 0;
              if (hasHeader && settings.headerBox?.content) {
                const lines    = (settings.headerBox.content.split("<br/>").length) || 1;
                const fontSize = settings.headerBox?.style?.fontSize || 18;
                const lineH    = settings.headerBox?.style?.lineHeight || 1.5;
                const paraGap  = settings.headerBox?.style?.paragraphSpacing || 8;
                actualHeaderH  = Math.max(155, lines * fontSize * lineH + (lines - 1) * paraGap + 14);
              } else if (hasHeader) {
                actualHeaderH = 155;
              }

              const headerTop  = topOff;
              const patientTop = topOff + actualHeaderH;
              const bodyTop    = patientTop + 32 + 6;
              const footerBot  = footerOff;
              const bodyBottom = footerOff + (hasFooter ? 52 : 0) + 4;

              return (
                <>
                  {/* ── HEADER ── */}
                  {hasHeader && (
                    <div style={{
                      position: "absolute",
                      top: headerTop,
                      left: 24, right: 24,
                      minHeight: actualHeaderH,
                      paddingBottom: 8,
                      boxSizing: "border-box",
                    }}>
                      {/* top accent bar */}
                      <div style={{ height: 4, background: "linear-gradient(90deg,#2D5A3D,#E8922A,#2D5A3D)", borderRadius: "2px 2px 0 0", marginBottom: 8 }} />
                      {/* logo absolute left, text centred */}
                      <div style={{ position: "relative", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <img src="/logo.png" alt="" style={{ position: "absolute", left: 0, top: "50%", transform: "translateY(-50%)", height: 64, width: "auto", objectFit: "contain" }} onError={e => { e.target.style.display = "none"; }} />
                        <div style={{ textAlign: "center" }}>
                          {/* English */}
                          <div style={{ fontFamily: "'Playfair Display',serif", fontSize: settings.headerBox.style.fontSize + 2, fontWeight: 800, color: "#2D5A3D", lineHeight: 1.2 }}>
                            Heramba Ayurveda
                          </div>
                          {/* Devanagari with side lines */}
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, margin: "3px 0 2px" }}>
                            <div style={{ height: 1.5, width: 30, background: "linear-gradient(90deg,transparent,#E8922A90)" }} />
                            <span style={{ fontFamily: "'Amita',serif", fontWeight: 700, fontSize: settings.headerBox.style.fontSize + 4, background: "linear-gradient(135deg,#E8922A,#B85C38,#C17A3A)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", letterSpacing: "0.06em" }}>
                              हेरम्ब आयुर्वेद
                            </span>
                            <div style={{ height: 1.5, width: 30, background: "linear-gradient(90deg,#E8922A90,transparent)" }} />
                          </div>
                          {/* Doctor text */}
                          <div style={{
                            fontFamily: settings.headerBox.style.fontFamily,
                            fontSize: settings.headerBox.style.fontSize - 1,
                            lineHeight: settings.headerBox.style.lineHeight,
                            fontWeight: settings.headerBox.tools.bold ? "700" : "400",
                            fontStyle: settings.headerBox.tools.italic ? "italic" : "normal",
                            textDecoration: settings.headerBox.tools.underline ? "underline" : "none",
                            color: "#2C1810", marginTop: 2,
                          }}>
                            {(settings.headerBox.content || "").split("<br/>").map((line, i) => (
                              <div key={i}>{line || "\u00A0"}</div>
                            ))}
                          </div>
                        </div>
                      </div>
                      {/* gold shimmer rule */}
                      <div style={{ height: 1.5, background: "linear-gradient(90deg,transparent,#E8922A,#B85C38,#E8922A,transparent)", marginTop: 7 }} />
                      {/* green border */}
                      <div style={{ height: 1, background: "#4A7C59", marginTop: 3 }} />
                    </div>
                  )}

                  {/* ── PATIENT ROW ── */}
                  <div style={{
                    position: "absolute",
                    top: patientTop,
                    left: 24, right: 24,
                    height: 32,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: 11,
                    borderBottom: "1px solid #e5e7eb",
                    boxSizing: "border-box",
                    color: "#374151",
                  }}>
                    <span><b>Name:</b> Patient Name</span>
                    <span><b>Age:</b> —</span>
                    <span><b>Gender:</b> —</span>
                    <span><b>Date:</b> {new Date().toLocaleDateString("en-IN")}</span>
                    <span><b>Rx#:</b> PREVIEW</span>
                  </div>

                  {/* ── BODY AREA ── */}
                  <div style={{
                    position: "absolute",
                    top: bodyTop,
                    bottom: bodyBottom,
                    left: 24, right: 24,
                    border: "1.5px dashed #93c5fd",
                    borderRadius: 4,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxSizing: "border-box",
                  }}>
                    <span style={{ fontSize: 12, color: "#93c5fd", fontFamily: "system-ui" }}>
                      ✍️ Prescription body area
                    </span>
                  </div>

                  {/* ── FOOTER ── */}
                  {hasFooter && (
                    <div style={{
                      position: "absolute",
                      bottom: footerBot,
                      left: 24, right: 24,
                      borderTop: "1px solid #d1d5db",
                      paddingTop: 4,
                      boxSizing: "border-box",
                      background: "#fff",
                      fontFamily: settings.footerBox.style.fontFamily,
                      fontSize: settings.footerBox.style.fontSize,
                      lineHeight: settings.footerBox.style.lineHeight,
                      textAlign: settings.footerBox.style.textAlign,
                      fontWeight: settings.footerBox.tools.bold ? "700" : "400",
                      fontStyle: settings.footerBox.tools.italic ? "italic" : "normal",
                      textDecoration: settings.footerBox.tools.underline ? "underline" : "none",
                    }}>
                      {(settings.footerBox.content || "").split("<br/>").map((line, i) => (
                        <div key={i}>{line || "\u00A0"}</div>
                      ))}
                    </div>
                  )}
                </>
              );
            })()}
          </div>
        </div>
      </div>

    </div>
  );
}